export default __webpack_public_path__ + "static/media/elephant.27f6f576.svg";